import i18n from "utils/i18n";
import { StorageHelper } from "utils/SessionStorageHelper";


function getBase64Image(img: HTMLImageElement) {
	var canvas = document.createElement("canvas");
	canvas.width = img.width;
	canvas.height = img.height;

	var ctx = canvas.getContext("2d");
	ctx!.drawImage(img, 0, 0);

	var dataURL = canvas.toDataURL("image/png");

	return dataURL;
}

const getImageFromStorage = (url: string): string => {
	var imageName = url.split("/").reverse()[0];
	if (!StorageHelper.getItem("imgData-" + imageName)) {
		var image = document.createElement("img");

		image.addEventListener("load", () => {
			var imgData = getBase64Image(image);
			StorageHelper.setItem("imgData-" + imageName, imgData);			
		});
		image.src = url;
		return url;
	} else {
		var dataImage = StorageHelper.getItem("imgData-" + imageName);

		return dataImage ?? url;
	}
};

const Logo = getImageFromStorage(process.env.PUBLIC_URL + "/customizations/assets/logoCliente.png");
const LogoSmall = getImageFromStorage(process.env.PUBLIC_URL + "/customizations/assets/logoClienteSmall.png");
const LogoHome = getImageFromStorage(process.env.PUBLIC_URL + "/customizations/assets/logoHomePageClient.png");
const LogoScheleton = getImageFromStorage(process.env.PUBLIC_URL + "/customizations/assets/logoScheleton.png");
const CssVariables = process.env.PUBLIC_URL + "/customizations/assets/variables-custom.css";
const CssStyles = process.env.PUBLIC_URL + "/customizations/assets/custom-styles.css";

var GetLocales = () => {
	var language = i18n.language.split("-")[0].toLocaleLowerCase();
	return {
		// PrivacyPolicy: process.env.PUBLIC_URL + `/locales/${language}/PrivacyPolicy.html`,
		CustomPrivacyPolicy: process.env.PUBLIC_URL + `/customizations/locales/${language}/PrivacyPolicy.html`,
		FaqDocument: process.env.PUBLIC_URL + `/customizations/locales/${language}/Faq.html`,
		CustomLanguages: process.env.PUBLIC_URL + `/customizations/locales/${language}/translation-custom.json`,
		TutorialPwa: process.env.PUBLIC_URL + `/customizations/pwatutorial/pwatutorial-${language}.html`,
	};
};

var fatchImages = () => {
	return {Logo ,LogoSmall,LogoHome,LogoScheleton}
	
};


export {  Logo, LogoSmall, LogoHome, CssVariables, CssStyles, GetLocales ,fatchImages};
